import type { ReactNode } from 'react';
import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import type { RootState } from 'reducers/types';
import { isEmbedded } from 'selectors';

type IsEmbeddedProps = ConnectedProps<typeof connector> & {
  children?: ReactNode;
};

const IsEmbeddedComponent = ({ children, isEmbedded }: IsEmbeddedProps) => {
  return isEmbedded ? <>{children}</> : null;
};

const mapStateToProps = (state: RootState) => ({
  isEmbedded: isEmbedded(state),
});

const connector = connect(mapStateToProps);

const IsEmbedded = connector(IsEmbeddedComponent);

export { IsEmbedded };
